/**
 * Almacenamiento de tokens del login embebido.
 *
 * Decisiones:
 *  - `sessionStorage` (no `localStorage`) → la sesión se borra al cerrar
 *    la pestaña. Evita que un equipo compartido herede credenciales.
 *  - El access_token también persiste para sobrevivir un F5; en memoria
 *    pura el usuario perdería sesión cada refresh.
 *  - No usamos cookies httpOnly porque el backend no maneja sesiones
 *    de servidor — todo el tráfico API va con `Authorization: Bearer`.
 */

const ACCESS_KEY = "licitai.access_token";
const REFRESH_KEY = "licitai.refresh_token";
const EXPIRES_AT_KEY = "licitai.expires_at"; // epoch ms

export interface StoredTokens {
  accessToken: string;
  refreshToken: string;
  /** Epoch ms en el que el access_token deja de ser válido. */
  expiresAt: number;
}

export function storeTokens(tokens: StoredTokens): void {
  sessionStorage.setItem(ACCESS_KEY, tokens.accessToken);
  sessionStorage.setItem(REFRESH_KEY, tokens.refreshToken);
  sessionStorage.setItem(EXPIRES_AT_KEY, String(tokens.expiresAt));
}

export function readTokens(): StoredTokens | null {
  const accessToken = sessionStorage.getItem(ACCESS_KEY);
  const refreshToken = sessionStorage.getItem(REFRESH_KEY);
  const expiresAtRaw = sessionStorage.getItem(EXPIRES_AT_KEY);
  if (!accessToken || !refreshToken || !expiresAtRaw) return null;
  const expiresAt = Number(expiresAtRaw);
  if (!Number.isFinite(expiresAt)) return null;
  return { accessToken, refreshToken, expiresAt };
}

export function clearTokens(): void {
  sessionStorage.removeItem(ACCESS_KEY);
  sessionStorage.removeItem(REFRESH_KEY);
  sessionStorage.removeItem(EXPIRES_AT_KEY);
}
